import { Button } from '@/components/button';
import { SimpleVisitPageContainer } from '@/components/simple-visit-page-container';
import { useTranslation } from '@/contexts/i18n-context';
import styles from './manual-request-page.module.css';
import { EmailSvg } from '@/components/svgs/email';

const translationBase = 'visit.identityVerification.manualRequest';

export function ManualRequestPage() {
  const { t } = useTranslation();

  return (
    <SimpleVisitPageContainer
      icon={<EmailSvg />}
      title={t(`${translationBase}.title`)}
      body={<p>{t(`${translationBase}.description`)}</p>}
      buttonContainer={
        <Button variant="filled" as="a" to="/" rightIcon="arrow_forward" className={styles.button}>
          {t(`${translationBase}.toDashboard`)}
        </Button>
      }
    />
  );
}
